import * as angular from 'angular';

import constants from './constants.js';

export default angular.module('fp:activationswizard:common:constants', [])
    .constant('constants', constants);